import { useScanEditingContextSlice } from '@/Client/State';
import { useNavigateToScan } from '@/Client/State/kaiNavigation';
import { pxToRem } from '@/Client/Styles/pxToRem';
import { css } from '@emotion/react';
import { COLORS2, LAYOUT2 } from '../../Styles';
import { Button, EditIcon, ProgressIcon, WarningIcon } from '../../Widgets';
import { useScopePrintPreviewContext } from './ScopePrintPreviewContext';

const ACTION_DROPDOWN_STYLE = css`
  background-color: ${COLORS2.alwaysDark.offWhite};
  border-top: solid 1px ${COLORS2.alwaysDark.lightGray};
  border-bottom: solid 1px ${COLORS2.alwaysDark.lightGray};
  padding: ${LAYOUT2.spacing2}px ${LAYOUT2.spacing2}px;

  @media print {
    display: none;
  }
`;

const BUTTON_WRAPPER_STYLE = css`
  display: flex;
  gap: ${LAYOUT2.spacing2}px;
  justify-content: center;

  button {
    flex: 0 0 130px;
    padding: 8px 16px !important;
    font-size: ${pxToRem(11)} !important;
  }
`;

export const SectionHeaderInlineActionDropdown = ({
  groupId,
}: {
  groupId: string;
}) => {
  const navigateToScan = useNavigateToScan();
  const { project, latestScan } = useScanEditingContextSlice(['project', 'latestScan']);
  const { currentDropdown, setCurrentDropdown } = useScopePrintPreviewContext();

  const isOpen = currentDropdown?.groupId === groupId && currentDropdown?.taskId === undefined;

  if (!isOpen) return null;

  const isApproved = !!project?.latestApprovedScan;

  const handleChangeClick = async () => {
    if (!latestScan) return;
    navigateToScan({ scanId: latestScan?.id, groupId, review: true });
    setCurrentDropdown(undefined);
  };

  const handleProgressClick = async () => {
    if (!latestScan) return;
    navigateToScan({ scanId: latestScan?.id, groupId, progress: true });
    setCurrentDropdown(undefined);
  };

  return (
    <div css={ACTION_DROPDOWN_STYLE}>
      <div css={BUTTON_WRAPPER_STYLE}>
        {isApproved
          ? (
            <>
              <Button
                buttonStyle='yellow'
                size='small'
                onClick={handleChangeClick}
              >
                <WarningIcon /> Change
              </Button>
              <Button
                buttonStyle='blue'
                size='small'
                onClick={handleProgressClick}
              >
                <ProgressIcon size={14} /> Progress
              </Button>
            </>
          )
          : (
            <Button
              buttonStyle='white'
              size='small'
              onClick={handleChangeClick}
            >
              <EditIcon /> Edit
            </Button>
          )}
      </div>
    </div>
  );
};
